/* angular:styles/component:css;d35029e15bc5c54fc612decc3bf5f158481e2c58a887f5cbacb25b02ceba8c9b;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/components/bv-mention/bv-mention-list.component.ts */
.scrollable-menu {
  display: block;
  height: auto;
  max-height: 300px;
  overflow: auto;
}
[hidden] {
  display: none;
}
li.active {
  background-color: rgba(249, 250, 252, 0.8);
}
.bv-mention-list {
  padding: 0;
  margin: 0;
  list-style: none;
  background-color: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
}
.bv-mention-list-item {
  color: #475056;
  font-size: 15px;
  padding: 6px;
  display: flex;
  flex-grow: 1;
  flex-direction: flex-start;
}
.media-image {
  margin-right: 10px;
}
/*# sourceMappingURL=bv-mention-list.component.css.map */
